module.exports = __webpack_public_path__ + "static/dmon-005-5676cdc7c956887c95d5e7c20901fb23.jpg";